import { EMPTY_OBJECT } from '../../../constants/common'
import { getUserListItemContentName } from '../../../utils/user'
import { isUserFullnameSystem } from '../User.utils'

export function toUserMultiValue(data, additionalData) {
  return {
    user: {
      ...additionalData,
      avatar: data.avatar,
      avatarColor: data.avatar_color,
      companyPostName: data.company_post_name,
      email: data.email,
      fullname: data.fullname,
      isSystem: data.is_system,
      key: data.id,
      role: data.role,
      status: data.status,
    },
  }
}

export function toUserMultiValueWithArchive(item) {
  return toUserMultiValue(item, { archived: item.archived })
}

export function getUserMultiValueName({ t, user }) {
  const { email, fullname, isSystem } = user || EMPTY_OBJECT

  return isSystem && isUserFullnameSystem(fullname)
    ? t(fullname)
    : getUserListItemContentName(email, fullname)
}
